import BottomNavigationIcon from './BottomNavigationIcon';
export default BottomNavigationIcon;
